import { MainButton, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import i18n from '../../../i18n/i18next'

interface ManageBookingsButtonProps {
    itemID: string
}

export const ManageBookingsButton = ({ itemID }: ManageBookingsButtonProps) => {
    return (
        <Stack spacing={'4px'}>
            <Typography variant="bodySubtext">
                {i18n.t('booking.bookedWithEventr')}
            </Typography>
            <MainButton
                onClick={() =>
                    window.pushPath(`/edit/hotelbooking/manage/${itemID}`)
                }
            >
                {i18n.t('booking.manageBookings')}
            </MainButton>
        </Stack>
    )
}
